<ng-template #rowActions let-client>
  <action-menu [items]="actionMenuItems" (clickAction)="actions[$event.valueOf()].emit(client)" [actionData]="client"></action-menu>
  <!-- <a
    mat-icon-button
    [routerLink]="['/clients', client.id]"
    aria-label="Detail"
    matTooltip="Detail"
  >
    <mat-icon>visibility</mat-icon>
  </a>

  @if ((client.isActive && canDeactivate()) || (!client.isActive && canActivate())) {
    <button
      mat-icon-button
      type="button"
      [disabled]="actionClientId() === client.id"
      (click)="toggled.emit(client)"
      [attr.aria-label]="client.isActive ? 'Deactivate' : 'Activate'"
      [matTooltip]="client.isActive ? 'Deactivate' : 'Activate'"
    >
      @if (actionClientId() === client.id) {
        <mat-spinner diameter="18" />
      } @else {
        <mat-icon>
          {{ client.isActive ? 'block' : 'check_circle' }}
        </mat-icon>
      }
    </button>
  }-->
</ng-template>

<data-table
  title="Clients"
  loadingMessage="Loading clients..."
  emptyMessage="No clients found."
  [rows]="clients()"
  [columns]="columns"
  [actionsTemplate]="rowActions"
  [loading]="loading()" />